import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Loader2, RotateCcw } from "lucide-react";
import { toast } from "sonner";

/** Botão para abrir/baixar arquivos: trava cliques repetidos, mostra a etapa ("Preparando documento…"/"Baixando…") e oferece "Tentar novamente" ao falhar. */
export function BotaoArquivo({ acao, children, preparando = "Preparando documento…", baixando = "Baixando…", testid, className = "", ...props }) {
  const [estado, setEstado] = useState("idle");
  const executar = async () => {
    if (estado === "preparando" || estado === "baixando") return;
    setEstado("preparando");
    try {
      await acao(() => setEstado("baixando"));
      setEstado("idle");
    } catch (e) {
      setEstado("erro");
      const msg = e?.response?.status === 404 ? "Arquivo indisponível. Solicite um novo envio." : e?.response?.data?.detail || "Não foi possível abrir o arquivo.";
      toast.error(msg, { action: { label: "Tentar novamente", onClick: executar } });
    }
  };
  const ocupado = estado === "preparando" || estado === "baixando";
  return (
    <Button {...props} className={`${className} ${ocupado ? "opacity-80" : ""}`} onClick={executar} disabled={props.disabled || ocupado} aria-busy={ocupado} data-testid={testid} data-estado={estado}>
      {ocupado ? <><Loader2 className="w-4 h-4 animate-spin" /> <span className="truncate">{estado === "preparando" ? preparando : baixando}</span></>
        : estado === "erro" ? <><RotateCcw className="w-4 h-4" /> Tentar novamente</> : children}
    </Button>
  );
}

/** Lê um blob da API avisando a etapa de transferência. */
export async function obterBlob(api, url, params, aoBaixar) {
  const resp = await api.get(url, { params, responseType: "blob", onDownloadProgress: () => aoBaixar?.() });
  aoBaixar?.();
  return resp;
}
